<div>
    <h4>
        {{ 'pages.dashboard.user.notificationPreferences' | translate }}
        <app-help message="{{ 'pages.dashboard.user.notificationPreferencesDesc' | translate }}"></app-help>
    </h4>

    <form *ngIf="notificationPreferences" class="row mx-0" [formGroup]="preferencesForm" (ngSubmit)="update()">
        <div *ngFor="let cat of notificationCategories"
            class="custom-control custom-switch right me-3"
            style="float: left"
            data-toggle="tooltip"
            data-placement="top"
            title="Enable {{ 'pages.dashboard.user.' + cat + 'Notifications' | translate}}"
        >   
            <input class="form-check-input" formControlName="{{cat}}" name="{{cat}}" type="checkbox" id="{{cat}}"/>
            <label class="custom-control-label" for="{{cat}}">{{ 'pages.dashboard.user.' + cat + 'Notifications' | translate}}</label>
            
        </div>
        <div class="my-3 col-12 px-0">
            <button type="submit" [disabled]="!preferencesForm.valid" class="btn btn-primary">{{ 'pages.generic.update' | translate }}</button>
        </div>
    </form>
</div>
